
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { PriceAdjustmentModel } from 'models/generated/Entities.Accounting.PriceAdjustment';


const _accounting_PriceAdjustmentControllerHelper = new Map<string, Object>();
_accounting_PriceAdjustmentControllerHelper.set('GetAllPriceAdjustments', PriceAdjustmentModel);


export const accounting_PriceAdjustmentControllerHelper = _accounting_PriceAdjustmentControllerHelper;

